import { useSurfacePreference } from "../../../hooks/use-surface-preference.ts"
import { surfaceKey } from "../../User/redux/ui-preferences.types.ts"

export type FilesView = "grid" | "list"

export const FILES_VIEW_PREFERENCE_KEY = surfaceKey("project.files.view")

export const DEFAULT_FILES_VIEW: FilesView = "grid"

export const useFilesView = (): [FilesView, (view: FilesView | null) => void] =>
  useSurfacePreference<FilesView>(FILES_VIEW_PREFERENCE_KEY, DEFAULT_FILES_VIEW)
